import { ECheckpointActions } from '@/store/checkpointStore/CheckpointStoreTypes'
import type { CheckpointLocales } from '@/types/lang/locales'

export const checkpointsEn: CheckpointLocales = {
    actions: {
        eraseDetections:
            'Re-initializing reads will erase each read currently saved. Are you sure ?',
        eraseDetectionsTitle: 'Re-initialize reads',

        unassignDevice: 'Do you want to unassign device {device} ?',
        reassignDevice: 'Do you want to reassign device {device} to checkpoint {checkpoint} ?',
        reassignDeviceTitle: 'Reassign device',

        deleteCheckpoint: {
            deleteCheckpointTitle: 'Delete checkpoint',
            deleteCheckpointContent:
                'Are you sure you want to delete this checkpoint ? This action cannot be undone.'
        }
    },
    api: {
        error: {
            [ECheckpointActions.CREATE_CHECKPOINT]:
                'An error occured while creating the checkpoint {name}',
            [ECheckpointActions.DELETE_CHECKPOINT]:
                'An error occured while deleting the checkpoint {name}',
            [ECheckpointActions.FETCH_CHECKPOINT]: 'An error occured while fetching the checkpoint',
            [ECheckpointActions.FETCH_CHECKPOINTS]:
                'An error occured while fetching the checkpoints',
            [ECheckpointActions.UPDATE_CHECKPOINT]:
                'An error occured while updating the checkpoint {name}',

            [ECheckpointActions.ASSOCIATE_DEVICE]: 'An error occured while associating device',
            [ECheckpointActions.ERASE_DETECTIONS]: 'An error occured while deleting detections'
        },
        success: {
            [ECheckpointActions.CREATE_CHECKPOINT]: 'Checkpoint {name} successfully created !',
            [ECheckpointActions.DELETE_CHECKPOINT]: 'Checkpoint {name} successfully deleted !',
            [ECheckpointActions.FETCH_CHECKPOINT]: 'Checkpoint successfully fetched',
            [ECheckpointActions.FETCH_CHECKPOINTS]: 'Checkpoints successfully fetched',
            [ECheckpointActions.UPDATE_CHECKPOINT]: 'Checkpoint {name} successfully edited !',

            [ECheckpointActions.ASSOCIATE_DEVICE]: 'Device successfully associated!',
            [ECheckpointActions.ERASE_DETECTIONS]: 'Reads successfully deleted!'
        }
    },
    buttons: {
        deleteCheckpoint: 'Delete checkpoint',
        forceAssociate: 'Force associate',
        hideAll: 'Hide additional checkpoints',
        showAll: 'Show all checkpoints'
    },
    filters: {
        name: "Filter by checkpoint's name"
    },

    model: {
        associates: 'Associated devices',
        comments: 'Comment',
        name: 'Checkpoint name',
        id: 'Hub Checkpoint ID '
    },
    detail: {
        alreadyAssociatedCheckpoints:
            'This device is already associated with one or more checkpoints, confirming association with this new checkpoint will disassociate it from all subsequent checkpoints :',
        associateDevice: 'Associate device',
        associates: 'Associate a device',
        dissociateDevice: 'Dissociate device',
        dissociateDeviceContent:
            'Are you sure you want to dissociate the device from the checkpoint ?',
        noDeviceAssociated: 'No device associated'
    },
    title: {
        actionsTitle: 'Actions',
        informationsTitle: 'Information',
        associateDeviceTitle: 'Associate devices',
        partnerTitle: "Partner's information"
    }
}
